<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .master -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('masterDiscussion.master')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="master"
                  vid="master"
                  rules="required"
                >
                  <b-form-select
                    v-model="master"
                    :options="masters"
                    text-field="name"
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('masterDiscussion.master')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .type -->
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('masterDiscussion.type')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="type"
                  vid="type"
                  rules="required"
                >
                  <b-form-input
                    id="input-2"
                    v-model="newItem.type"
                    type="text"
                    :placeholder="$t('masterDiscussion.type')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .date -->
            <b-col lg="6">
              <b-form-group
                id="input-group-3"
                :label="$t('masterDiscussion.date')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="date"
                  vid="date"
                  rules="required"
                >
                  <b-form-input
                    id="input-3"
                    v-model="newItem.date"
                    type="text"
                    :placeholder="$t('masterDiscussion.date')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .online_class -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('masterDiscussion.online_class')"
                label-for="input-4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="online_class"
                  vid="online_class"
                  rules="required"
                >
                  <b-form-select
                    v-model="online_class"
                    :options="online_classs"
                    text-field="name"
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('masterDiscussion.online_class')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .meta_data -->
            <b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('masterDiscussion.meta_data')"
                label-for="input-5"
              >
                <validation-provider
                  #default="{ errors }"
                  name="meta_data"
                  vid="meta_data"
                  rules="required"
                >
                  <b-form-input
                    id="input-5"
                    v-model="newItem.meta_data"
                    type="text"
                    :placeholder="$t('masterDiscussion.meta_data')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/MasterDiscussionController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  name: "MasterDiscussionForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
      master: [],
      online_class: [],
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>

